import { render, staticRenderFns } from "./IdentityDocumentWithTypeSelectionList.vue?vue&type=template&id=5f2b7f5f&scoped=true&"
import script from "./IdentityDocumentWithTypeSelectionList.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentWithTypeSelectionList.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDocumentWithTypeSelectionList.vue?vue&type=style&index=0&id=5f2b7f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b7f5f",
  null
  
)

export default component.exports